import { ReactNode, useCallback } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";

import {
    FlatButton,
} from "src/framework/components/buttons";

import "./style.css";
import { useObservable } from "src/framework/store/storeUtil";
import { INotifier, notifier$, notifierDialogController, openNotifier$, percent$, showProgress$ } from "./store";

const Notifier = () => {
    const open = useObservable<boolean>(openNotifier$);
    const setup = useObservable<INotifier>(notifier$);
    const percent = useObservable(percent$);
    const showProgress = useObservable(showProgress$);
    
    const contentNotifier = useCallback((content: any): ReactNode => {
        if (typeof content === "string") {
            return <>{content}</>
        } else {
            if (Array.isArray(content)) {
                return <>{content.map(rec => <>{rec}<br /></>)}</>
            } else {
                return content;
            }
        }
    }, []);

    return (
        <div>
            <Dialog open={open || false} style={{ minWidth: "300px" }}>
                <div
                    onMouseEnter={() => notifierDialogController.onMouseEnter()}
                    id="notifier-container"
                >
                    {showProgress ? (
                        <LinearProgress
                            id="timeout-progress"
                            variant="determinate"
                            value={percent || 0}
                        />
                    ) : (
                        ""
                    )}
                    <DialogTitle id="simple-dialog-title">
                        {setup?.title}
                    </DialogTitle>
                    <DialogContent style={{ minWidth: "300px" }}>
                        <DialogContentText id="alert-dialog-description">
                            {contentNotifier(setup?.content)}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <FlatButton 
                            text="Ok"
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                notifierDialogController.close()
                            }}
                        />
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
}

export { Notifier };
